/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
import v2c from "../../../public/changelog/v2c.png";
export const meta = {
  id: 8,
  image: "default-changelog-v2.png",
  title: "Changelog Notes - V3.0.8-beta",
  shortDescription: "We are introducing our dedicated IPFS gateway for all the PInata & Filecoin deployments",
  description: "We are introducing our dedicated IPFS gateway for all the PInata & Filecoin deployments",
  date: "Aug 11th, 2022",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["performance", "arweave", "CD", "improvement", "bug", "fixes"]
};
export const content = ` 
## Dedicated IPFS Gateway

We are introducing our dedicated IPFS gateway for all the PInata & Filecoin deployments. Your deployments on IPFS can now be accessed using our IPFS gateway - \`spheron.infura-ipfs.io\`. This will fix the recent outages of all the sites deployed on IPFS and using the Infura public IPFS gateway.

## Fixes 🛠

We've shipped some bug fixes from your feedback to improve your product experience.

**Here are some of the recent ones**.

- **Redeploy Project:** We fixed the issue of not being able to change the protocol when redeploying your project.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
